import styled, { keyframes, css } from 'styled-components';
import zindex from '#app/interface/zindex';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const materialStyle = keyframes`
  from {
    opacity: 0;
    box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  }
  to {
    opacity: 1;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  }
`;

export const Overlay = styled.div.attrs({ className: 'overlay-container' })`
  overflow-y: auto;
  position: fixed;
  top: 0 !important;
  left: 0 !important;
  width: 100%;
  height: 100%;
  text-align: center;
  vertical-align: middle;
  z-index: ${zindex.modal};
  background-color: rgba(0, 0, 0, 0.7);
  overflow-x: hidden;

  & > div {
    position: absolute;
    height: fit-content;
    min-height: 1400px;
    top: 0 !important;
    left: 0 !important;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  top: 0 !important;
  left: 0 !important;
  width: 100%;
  height: 100vh;
  line-height: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: ${zindex.modal};
`;

export const Modal = styled.div`
  background-color: #fff;
  display: inline-block;
  position: relative;
  top: 100px;
  border-radius: 24px;
  transition:
    opacity 0.3s ease,
    box-shadow 0.3s ease,
    transform 0.3s ease;

  ${(props) =>
    (props.size === undefined || !props.size) &&
    `
    min-width: 70%;
    max-width: 70%;
  `}
  ${(props) =>
    props.size === 'extra-small' &&
    `
    width: 100%;
    max-width: 440px;
  `}
  ${(props) =>
    props.size === 'very-small' &&
    `
    width: 100%;
    max-width: 640px;
  `}
  ${(props) =>
    props.size === 'small' &&
    `
    width: 100%;
    max-width: 786px;
  `}
  ${(props) =>
    props.size === 'medium' &&
    `
    width: 100%;
    max-width: 900px;
  `}
  ${(props) =>
    props.size === 'large' &&
    `
    width: 100%;
    max-width: 1200px;
  `}
  ${(props) =>
    props.size === 'extra-large' &&
    `
    width: 100%;
    max-width: 1400px;
  `}
  ${(props) =>
    props.size === 'avatar' &&
    `
    width: 100%;
    max-width: 568px;
  `}

  /* Анимация при открытии (опционально) */
  ${(props) =>
    props['data-should-animate'] === 'true' &&
    css`
      opacity: 0;
      box-shadow: 0 0 0 rgba(0, 0, 0, 0);
      animation: ${materialStyle} 0.6s ease-out forwards;
    `}
`;

export const ModalHeader = styled.div`
  align-items: center;
  background-color: #fff;
  display: flex;
  flex-shrink: 0;
  justify-content: flex-start;
  padding: 20px 20px 0 40px;
  position: relative;
  color: #363636;
  flex: 1;
  font-size: 24px;
  line-height: 1;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  font-weight: 600;
  height: 60px;
  cursor: grab;

  &[data-dragging='true'] {
    cursor: grabbing;
  }
`;

export const ModalTitle = styled.h2`
  width: 100%;
  text-align: left;
  color: #000;
  font-size: 20px;
  margin: 0;
`;

export const ModalContent = styled.div`
  background-color: white;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 5px 20px 5px 20px;
  overflow: visible;

  ${(props) =>
    props.type === 'scroll' &&
    `
    overflow: auto;
    height: 600px;
  `}
`;

export const ModalFooter = styled.div`
  align-items: center;
  background-color: #fff;
  display: flex;
  flex-shrink: 0;
  justify-content: flex-start;
  padding: 5px 20px 20px 20px;
  position: relative;
  color: #363636;
  flex-grow: 1;
  font-size: 1.5rem;
  flex-wrap: wrap;
  line-height: 1;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;

  ${(props) =>
    props.type === 'scroll' &&
    `
    overflow: auto;
    height: 600px;
  `}
`;

export const ModalClose = styled.span`
  background-color: #fff;
  padding: 4px;
  position: absolute;
  top: 10px;
  right: 10px;
  border-radius: 72px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  line-height: 20px;
`;

export const ModalCloseLanding = styled.span`
  background-color: #f5f5f5;
  padding: 4px;
  position: absolute;
  top: 10px;
  right: 10px;
  border-radius: 72px;
  cursor: pointer;
  width: 32px;
  height: 32px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    width: 16px;
    height: 16px;
  }
`;

export const ModalLoader = styled.span`
  position: absolute;
  top: 30px;
  left: 30px;
  animation: ${rotate} 2s linear infinite;
`;

export const WrapperLoader = styled.div`
  position: relative;
  top: 0 !important;
  left: 0 !important;
  width: 100%;
  height: 100vh;
  line-height: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: ${zindex.modal};
`;

export const BlockLoader = styled.div`
  background-color: #fff;
  position: absolute;
  width: 100px;
  height: 100px;
  top: calc(50% - 50px);
  left: calc(50% - 50px);
  border-radius: 24px;
`;

const loaderSvg = require('#app/assets/images/loader.svg');
export const LoaderSpinner = styled.span`
  animation: ${rotate} 2s linear infinite;
  background-image: url(${loaderSvg});
  background-size: 100%, contain, cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 75px;
  height: 75px;
  margin: 14px auto;
  display: block;
`;
